import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const multiStyleConfigHelpers = createMultiStyleConfigHelpers([
  'root',
  'indicator',
  'title',
  'description',
  'link'
]);

export const StatusCardTheme = multiStyleConfigHelpers.defineMultiStyleConfig({
  baseStyle: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2.5,
      padding: 4,
      textAlign: 'left',
      borderWidth: 1,
      borderStyle: 'solid',
      borderRadius: 4,
      color: 'text.prominent',
      boxSizing: 'border-box'
    },
    link: {
      alignSelf: 'start',
      textStyle: 'h200',
      outline: 'none',
      _hover: {
        textDecoration: 'underline'
      },
      _focusVisible: {
        outline: '1px solid'
      }
    }
  },
  variants: {
    warning: {
      root: {
        backgroundColor: 'background.status.default.warning',
        borderColor: 'background.container.warning'
      },
      indicator: {
        color: 'icon.status.onWarningContainer'
      },
      link: {
        color: 'icon.status.onWarningContainer',
        _hover: {
          color: 'icon.status.onWarningContainer'
        },
        _focusVisible: {
          outlineColor: 'icon.status.onWarningContainer'
        }
      }
    },
    success: {
      root: {
        backgroundColor: 'background.status.default.success',
        borderColor: 'background.container.success'
      },
      indicator: {
        color: 'icon.status.onSuccessContainer'
      },
      link: {
        color: 'icon.status.onSuccessContainer',
        _hover: {
          color: 'icon.status.onSuccessContainer'
        },
        _focusVisible: {
          outlineColor: 'icon.status.onSuccessContainer'
        }
      }
    },
    alert: {
      root: {
        backgroundColor: 'background.status.default.alert',
        borderColor: 'background.container.alert'
      },
      indicator: {
        color: 'icon.status.onAlertContainer'
      },
      link: {
        color: 'icon.status.onAlertContainer',
        _hover: {
          color: 'icon.status.onAlertContainer'
        },
        _focusVisible: {
          outlineColor: 'icon.status.onAlertContainer'
        }
      }
    }
  }
});
